// Plantillas de mensaje de WhatsApp: textos para la persona y ayudas del formulario. Las reglas de verdad las revisa el motor
// (agent-runtime/src/channels/templates.ts) y luego Meta; aquí solo se anticipan para avisar mientras se escribe.

export const LANGUAGES = [
  { value: 'es_MX', label: 'Español (México)' },
  { value: 'es', label: 'Español' },
  { value: 'en_US', label: 'Inglés (Estados Unidos)' },
  { value: 'en', label: 'Inglés' },
];

export const CATEGORIES = [
  { value: 'UTILITY', label: 'Utilidad', hint: 'Avisos de algo que la persona pidió o ya tiene: citas, pedidos, pagos, seguimiento.' },
  { value: 'MARKETING', label: 'Marketing', hint: 'Promociones, ofertas o invitaciones. Meta las cobra más caras y la persona puede bloquearlas.' },
];

export const STATUS = {
  APPROVED: { tone: 'live', label: 'Aprobada' },
  PENDING: { tone: 'caution', label: 'En revisión' },
  IN_APPEAL: { tone: 'caution', label: 'En apelación' },
  REJECTED: { tone: 'signal', label: 'Rechazada' },
  PAUSED: { tone: 'signal', label: 'Pausada' },
  DISABLED: { tone: 'signal', label: 'Desactivada' },
};
export const statusOf = (s) => STATUS[s] || { tone: 'neutral', label: s ? s.toLowerCase() : 'Sin estado' };

// Motivos de rechazo de Meta más comunes, en palabras de la persona.
const REASONS = {
  INVALID_FORMAT: 'El formato no es válido (revisa las variables y que no empiece ni termine con una).',
  INCORRECT_CATEGORY: 'Meta cree que la categoría no corresponde al texto.',
  PROMOTIONAL: 'Meta lo considera promocional: usa la categoría Marketing.',
  ABUSIVE_CONTENT: 'Meta encontró contenido que no permite.',
  TAG_CONTENT_MISMATCH: 'El texto no coincide con la categoría o el idioma elegidos.',
  SCAM: 'Meta lo marcó como posible engaño.',
};
export const reasonText = (r) => (r ? REASONS[r] || `Meta respondió: ${r}` : '');

export const languageLabel = (v) => LANGUAGES.find((l) => l.value === v)?.label || v;
export const categoryLabel = (v) => CATEGORIES.find((c) => c.value === v)?.label || v;

/** Cuántas variables distintas tiene el texto ({{1}}, {{2}}…). */
export function variableCount(text) {
  return new Set([...String(text || '').matchAll(/\{\{\s*(\d+)\s*\}\}/g)].map((m) => m[1])).size;
}

/** Convierte un nombre escrito a mano en uno que Meta acepta: minúsculas, sin acentos, guion bajo. */
export function toTemplateName(s) {
  return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
    .replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 512);
}

/** El texto con los valores puestos, para la vista previa. Las variables sin valor quedan como {{n}}. */
export function fillVariables(text, values) {
  return String(text || '').replace(/\{\{\s*(\d+)\s*\}\}/g, (m, n) => (values?.[Number(n) - 1] ? values[Number(n) - 1] : m));
}

/** Avisos mientras se escribe (los mismos que daría el motor). Lista vacía = lista para enviar a revisión. */
export function draftProblems(d) {
  const out = [];
  if (!/^[a-z0-9_]+$/.test(d.name || '')) out.push('Ponle un nombre (solo minúsculas, números y guion bajo).');
  const body = (d.body || '').trim();
  if (!body) out.push('Escribe el texto del mensaje.');
  const nums = [...new Set([...body.matchAll(/\{\{\s*(\d+)\s*\}\}/g)].map((m) => Number(m[1])))].sort((a, b) => a - b);
  if (nums.some((n, i) => n !== i + 1)) out.push('Numera las variables en orden desde {{1}}.');
  if (nums.length && (/^\{\{\s*\d+\s*\}\}/.test(body) || /\{\{\s*\d+\s*\}\}[.!?…]?$/.test(body))) out.push('El mensaje no puede empezar ni terminar con una variable.');
  if (nums.some((_, i) => !(d.examples?.[i] || '').trim())) out.push('Escribe un ejemplo para cada variable.');
  if (body.length > 1024) out.push('El texto del mensaje no puede pasar de 1024 caracteres.');
  if ((d.header || '').length > 60) out.push('El encabezado no puede pasar de 60 caracteres.');
  if ((d.footer || '').length > 60) out.push('El pie no puede pasar de 60 caracteres.');
  if ((d.buttons || []).some((b) => b.length > 25)) out.push('Cada botón puede tener hasta 25 caracteres.');
  return out;
}
